export default __webpack_public_path__ + "static/media/culture-centres-future.a6333edb.png";